<template>
<div id="index">


  <div class="common-seach-wrap">
    <el-form size="small" :inline="true" :model="searchObj">
      <el-form-item label="昵称/手机号">
        <el-input v-model="searchObj.search" placeholder="请输入昵称/手机号"></el-input>
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input v-model="searchObj.user_id" placeholder="请输入用户ID"></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-input v-model="searchObj.brand" placeholder="请输入品牌"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchObj.status" placeholder="请选择鉴定状态">
          <el-option v-for="item in ststuaList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="pageChange(1)">查询</el-button>
      </el-form-item>
    </el-form>
  </div>



  <!-- <div class="common-level-rail">
    <el-button size="small" type="primary" @click="$refs.addEdit.show()" icon="el-icon-plus" v-auth="'/appraisal/appraisal/add'">添加成色</el-button>
  </div> -->

  <div class="product-content">
    <div class="table-wrap">
      <el-table size="small" :data="list">
        <!-- 鉴定ID（倒序） -->
        <el-table-column prop="appraisal_id" label="ID" width="90"></el-table-column>
        <el-table-column  label="鉴定用户" width="200">
          <template slot-scope="scope">
            <div class="userInfo">
              <img :src="scope.row.user.avatarUrl" alt="">
              <div class="main">
                <p class="name">{{ scope.row.user.nickName }}</p>
                <p class="text">ID:{{ scope.row.user.user_id }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 资产类型：替代原来的鉴定品类 category_id，更符合前端六大类型 -->
        <el-table-column prop="asset_type_text" label="资产类型"></el-table-column>
        <el-table-column prop="brand_text" label="品牌"></el-table-column>
        <el-table-column prop="fineness_text" label="成色"></el-table-column>
        <el-table-column label="附件">
          <template slot-scope="scope">
            {{ attachmentDisplay(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="正面照" width="140">
          <template slot-scope="scope">
            <template v-if="scope.row.front && scope.row.front.file_path">
              <el-image v-if="isImage(scope.row.front.file_path)" :src="scope.row.front.file_path" fit="fill" :preview-src-list="[scope.row.front.file_path]" style="width: 50px; height: 50px;"></el-image>
              <span v-else class="doc-file-wrap">
                <span class="doc-name">{{ scope.row.front.file_name || scope.row.front.real_name || '正面照' }}</span>
                <a v-if="isPdf(scope.row.front)" :href="scope.row.front.file_path" target="_blank" class="doc-btn">预览</a>
                <a :href="scope.row.front.file_path" :download="scope.row.front.file_name || scope.row.front.real_name || '正面照'" target="_blank" class="doc-btn">下载</a>
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="反面照" width="140">
          <template slot-scope="scope">
            <template v-if="scope.row.back && scope.row.back.file_path">
              <el-image v-if="isImage(scope.row.back.file_path)" :src="scope.row.back.file_path" fit="fill" :preview-src-list="[scope.row.back.file_path]" style="width: 50px; height: 50px;"></el-image>
              <span v-else class="doc-file-wrap">
                <span class="doc-name">{{ scope.row.back.file_name || scope.row.back.real_name || '反面照' }}</span>
                <a v-if="isPdf(scope.row.back)" :href="scope.row.back.file_path" target="_blank" class="doc-btn">预览</a>
                <a :href="scope.row.back.file_path" :download="scope.row.back.file_name || scope.row.back.real_name || '反面照'" target="_blank" class="doc-btn">下载</a>
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag size="small" :type="ststuaList.find(item=>item.value==scope.row.status).type">{{ ststuaList.find(item=>item.value==scope.row.status).label }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="鉴定结果描述" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.result_desc || '-' }}</template>
        </el-table-column>
        <el-table-column label="鉴定结果文件" width="160">
          <template slot-scope="scope">
            <template v-if="scope.row.resultDoc && scope.row.resultDoc.file_path">
              <span class="doc-file-wrap">
                <span class="doc-name">{{ scope.row.resultDoc.real_name || scope.row.resultDoc.file_name || '鉴定结果' }}</span>
                <a v-if="isPdf(scope.row.resultDoc)" :href="scope.row.resultDoc.file_path" target="_blank" class="doc-btn">预览</a>
                <a :href="scope.row.resultDoc.file_path" :download="scope.row.resultDoc.real_name || scope.row.resultDoc.file_name || '鉴定结果'" target="_blank" class="doc-btn">下载</a>
              </span>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="160"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="$refs.detail.show(scope.row,'detail')" type="text" size="small" v-auth="'/appraisal/appraisal/detail'">详情</el-button>
            <el-button v-if="!scope.row.resultImage&&scope.row.status==0" @click="$refs.detail.show(scope.row,'result')" type="text" size="small" v-auth="'/appraisal/appraisal/addResultImage'">鉴定</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>

  <div class="pagination">
    <el-pagination
      @current-change="pageChange"
      background
      :current-page="searchObj.page"
      :page-size="searchObj.list_rows"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>


  <Detail ref="detail" @refresh="getData"></Detail>


</div>
</template>

<script>
import Detail from './detail.vue';
import AppraisalApi from '@/api/appraisal'
import { MAIN_KEY, fetchTaggedOptionsMerge, FALLBACK_APPRAISAL_STATUS } from '@/utils/sysEnumOptions'
export default {
  components:{Detail},
  data() {
    return {
      searchObj:{
        page:1,
        list_rows:10,
        search:'',
        user_id:'',
        status:'-1',
        brand:'',
      },
      // -1=全部，0=鉴定中，1=已完成，2=已取消
      ststuaList: [...FALLBACK_APPRAISAL_STATUS],
      list: [],
      total:0,
    }
  },
  created(){
    fetchTaggedOptionsMerge(MAIN_KEY.appraisalListStatus, FALLBACK_APPRAISAL_STATUS)
      .then(list => {
        const hasAll = (list || []).some(o => String(o.value) === '-1')
        const allRow = FALLBACK_APPRAISAL_STATUS[0]
        this.ststuaList = hasAll ? list : [allRow, ...(list || [])]
      })
      .catch(() => {})
    this.getData()
  },
  methods:{

    /** 附件展示：使用 accessory_list（由 accessory_codes 映射的中文标签数组） */
    attachmentDisplay(row) {
      if (!row || !row.accessory_list || !row.accessory_list.length) return ''
      return row.accessory_list.join('、')
    },
    isImage(path) {
      if (!path) return false
      const lower = String(path).toLowerCase()
      return /\.(jpe?g|png|gif|webp|bmp)$/.test(lower)
    },
    isPdf(item) {
      if (!item) return false
      const p = (item.file_path || item.file_name || item.real_name || '').toLowerCase()
      return p.indexOf('.pdf') !== -1
    },

    getData(){
      AppraisalApi.appraisalIndex(this.searchObj).then(result=>{
        let list=result.data.list
        this.list=list.data
        this.total=list.total
      })
    },

    // 分页
    pageChange(e){
      this.searchObj.page=e
      this.getData()
    },

  }
}
</script>

<style lang="scss" scoped>
.userInfo{display: flex;
  img{width: 40px;height: 40px;}
  .main{flex: 1;padding-left: 10px;
    .name{font-size: 14px;font-weight: bold;}
    .text{color:#999;}
  }
}
.doc-btn{font-size: 12px;color: #409EFF;text-decoration: none;display: inline-block;margin-top: 2px;}
.doc-btn:hover{text-decoration: underline;}
.doc-file-wrap{display: inline-flex;align-items: center;flex-wrap: wrap;gap: 4px;}
.doc-file-wrap .doc-name{font-size: 12px;max-width: 80px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
</style>


// WEBPACK FOOTER //
// src/views/appraisal/appraisal/index.vue